import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getDocumentsIds = createAsyncThunk('documentsIds/get', API.documentsIds.get);

export const getDocumentId = createAsyncThunk('documentsIds/getById', API.documentsIds.getByDocId);

export const updateDocumentId = createAsyncThunk(
  'documentsIds/update',
  async ({ id, enabled, docId }: { id: string; enabled: string; docId: string }) =>
    API.documentsIds.update({ id, enabled, docId }),
);
